import * as React from 'react';

import { Member } from 'common/api/models/Member';

export interface LinkedinLinkProps {
  member?: Member;
}
export const LinkedinLink: React.SFC<LinkedinLinkProps> = props => {
  const member = props.member;
  if (!member || !member.social || !member.social.linkedin) {
    return <span>None</span>;
  }
  const url = 'https://www.linkedin.com/' + member.social.linkedin;
  return (
    <a href={url} target="_blank" rel="noopener">
      <i className="fa fa-linkedin" />
    </a>
  );
};



// WEBPACK FOOTER //
// ./src/common/components/link/LinkedinLink.tsx